// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__t9xuK","mainLimit":"Layout_mainLimit__2eVHX"};